import React, { FC } from 'react';
import { ReactComponent as Facebook } from '../../../assets/SocialMedia/Facebook.svg';

export const FacebookIcon: FC = () => <Facebook />;
